// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28rLA","questions":"styles_questions__3GFrb","footer":"styles_footer__NpJ-z"};